import { TextField, InputAdornment } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import type { FC } from 'react';

/**
 * Molecule: Currency input with formatting
 * Following form-architecture.md Controller pattern
 */
export const PriceInputField: FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name="price"
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          label="Price *"
          type="number"
          fullWidth
          error={!!errors.price}
          helperText={
            errors.price?.message?.toString() ||
            'Adjust price for this specific plot'
          }
          InputProps={{
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
          }}
          onChange={e => {
            const value = parseFloat(e.target.value);
            field.onChange(isNaN(value) ? 0 : value);
          }}
        />
      )}
    />
  );
};
